/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const trafficCheckinStyle = {
  formPaper: {
    padding: { xs: "20px", lg: "20px 40px" },
  },
  gridSpaceAccusation: (theme: Theme) => ({
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3rem",
    },
  }),
  gridSpaceEmail: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
  }),
  buttonContainer: {
    marginRight: "auto",
    marginLeft: "auto",
  },
  heading: {
    textAlign: "center",
  },
  button: {
    marginTop: "25px",
  },
  classification: {
    width: "100%",
  },
  email: {
    width: "100%",
  },
  default: {
  },
  grey: {
    backgroundColor: "background.contrast",
  },
};

export default trafficCheckinStyle;
